<template>
  <v-card>
    <div
      class="hogans-modal-header"
      v-bind:style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2>Cast toevoegen</h2>
      <div
        class="hogans-modal-header-close"
        @click="closeAddCastDialog()"
      ></div>
    </div>

    <v-alert class="ma-0 pa-2" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>
    <v-divider></v-divider>

    <v-card-text>
      <v-text-field
        label="Titel"
        v-model="newCast.title"
        :rules="requiredRules"
        required
      ></v-text-field>

      <div class="upload-news-image-wrapper clear">
        <div class="upload-image">
          <p>Upload afbeelding</p>
          <div v-if="newCast.Image" class="logo-upload-preview">
            <v-img :src="newCast.Image" aspect-ratio="1" class="grey lighten-2">
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <div v-if="uploading == true" class="upload-bar">
              <p>{{ uploadProgress }} %</p>
              <div
                class="upload-bar-inner"
                v-bind:style="{ backgroundColor: companyPrimaryColor }"
              ></div>
            </div>
          </div>
          <v-btn
            class="ma-0"
            raised
            :color="companyPrimaryColor"
            dark
            @click="onFileSelect"
            >Kies afbeelding</v-btn
          >
          <input
            type="file"
            style="display: none;"
            ref="fileInput"
            accept="image/*"
            @change="onFilePicked"
          />
        </div>
      </div>

      <div class="field-wrapper" style="max-width: 100%; overflow: hidden;">
        <v-tooltip right>
          <template slot="activator">
            <label class="custom-label"
              >Omschrijving<v-icon small right :color="companyPrimaryColor"
                >help</v-icon
              ></label
            >
          </template>
          <span style="color: #fff;"
            >Omschrijving van de cast voor gebruikers.</span
          >
        </v-tooltip>
        <ckeditor
          type="classic"
          :upload-adapter="UploadAdapter"
          v-model="newCast.description"
          :config="editorConfig"
        ></ckeditor>
      </div>

      <v-container style="padding: 0">
        <v-layout row wrap style="padding: 10px 0">
          <v-flex xs6>
            <v-text-field
              label="Auteur"
              v-model="newCast.uploadedBy"
              :rules="requiredRules"
              hint="Wie heeft de cast gemaakt?"
              persistent-hint
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs6 style="padding: 0 0 0 15px">
            <v-text-field
              label="Afspeeltijd"
              v-model.number="newCast.delay"
              type="number"
              onkeydown="return event.keyCode !== 69"
              :rules="requiredRules"
              suffix="seconden"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap style="padding: 10px 0">
          <v-flex xs6>
            <v-menu
              ref="dateDialog"
              :close-on-content-click="false"
              v-model="startDateDialog"
              lazy
              transition="scale-transition"
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                :color="companyPrimaryColor"
                slot="activator"
                v-model="startDateFormatted"
                label="Startdatum"
                hide-details
                readonly
              ></v-text-field>
              <v-date-picker
                :color="companyPrimaryColor"
                v-model="newCast.startDate"
                :min="today"
                :show-current="true"
                no-title
                @input="startDateDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 style="padding: 0 0 0 15px">
            <v-menu
              ref="endDateDialog"
              :close-on-content-click="false"
              v-model="endDateDialog"
              lazy
              transition="scale-transition"
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                :color="companyPrimaryColor"
                slot="activator"
                v-model="endDateFormatted"
                label="Einddatum"
                hide-details
                readonly
              ></v-text-field>
              <v-date-picker
                :color="companyPrimaryColor"
                v-model="newCast.endDate"
                :show-current="true"
                :min="today"
                no-title
                @input="endDateDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-container>

      <v-switch
        :color="companyPrimaryColor"
        v-model="newCast.published"
        class="pa-0"
        hide-details
      >
        <template slot="label">
          <span style="color: #333; margin-right: 5px;">Publiceren</span>
          <v-tooltip class="ma-0 pa-0" right>
            <v-icon small :color="companyPrimaryColor" slot="activator"
              >help</v-icon
            >
            <span style="color: #fff;"
              >Cast wordt alleen getoond op screencloud als deze actief
              is.</span
            >
          </v-tooltip>
        </template>
      </v-switch>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <div class="hogans-modal-footer clear">
        <v-btn
          class="modal-button-cancel"
          outline
          depressed
          color="#8B93A6"
          @click="closeAddCastDialog()"
          >Annuleren</v-btn
        >
        <v-btn
          class="modal-button-next"
          dark
          round
          :color="companyPrimaryColor"
          @click="addCast()"
          >Cast toevoegen<v-icon right dark>arrow_forward_ios</v-icon></v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import { Chrome } from "vue-color";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import platform from "platform";

export default {
  name: "add-cast-form",
  props: ["activeCompData"],
  data() {
    return {
      editorConfig: {
        toolbar: [
          "heading",
          "bold",
          "italic",
          "bulletedList",
          "numberedList",
          "|",
          "link",
          "ImageUpload",
          "|",
          "insertTable",
          "|",
          "undo",
          "redo",
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
      },
      startDateDialog: false,
      endDateDialog: false,
      valid: false,
      newCast: {
        title: null,
        published: true,
        description: "",
        uploadedBy: null,
        startDate: null,
        endDate: null,
        Image: null,
        company: "",
        delay: 15,
      },
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      valid: true,
      filename: null,
      Image: null,
      feedback: null,
      uploading: false,
      uploadProgress: null,
      file: {},
    };
  },

  created() {
    // Datum van vandaag alvast invullen al publicatiedatum en vandaag als de maximale datum zetten
    this.today = moment().format("YYYY-MM-DD");
    this.newCast.startDate = moment().format("YYYY-MM-DD");
    this.newCast.endDate = moment().format("YYYY-MM-DD");
  },

  methods: {
    closeAddCastDialog() {
      // Dialog sluiten en waardes resetten
      this.$emit("newCastDialogChange", false);
      this.newCast = {
        title: null,
        description: "",
        published: true,
        uploadedBy: null,
        startDate: "",
        endDate: "",
        Image: null,
        delay: null,
      };
      this.feedback = null;
    },

    onFileSelect() {
      // Openen van selectievenster in browser
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      // Afbeelding selecteren
      const files = event.target.files;
      this.file = files[0];
      let filename = files[0].name;
      this.filename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.newCast.Image = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.Image = files[0];
      this.feedback = null;
    },

    UploadAdapter(loader) {
      let token = Math.random()
        .toString(36)
        .substr(2);
      this.loader = loader;

      let company = "hogans";
      let imageUrl = "";
      loader.file.then((response) => {
        this.upload = () => {
          return new Promise((resolve, reject) => {
            const file = response;
            const filename = response.name;

            const ext = filename.slice(filename.lastIndexOf("."));
            const fileUrl = "wysiwyg/" + filename + "-" + token + ext;

            let uploadTask = firebase
              .storage()
              .ref(fileUrl)
              .put(file);

            uploadTask.on(
              "state_changed",
              (taskSnapshot) => {},
              (error) => {
                console.error(error);
                reject();
              },
              () => {
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then((url) => {
                    imageUrl = url;
                    resolve();
                  })
                  .catch((error) => {
                    reject();
                  });
              },
            );
          }).then(() => {
            return {
              default: imageUrl,
            };
          });
        };
      });
    },

    addCast() {
      this.feedback = null;
      if (
        this.newCast.Image &&
        this.newCast.description &&
        this.newCast.title
      ) {
        db.collection("Casting")
          .add({
            title: this.newCast.title,
            description: this.newCast.description,
            published: this.newCast.published,
            startDate: new Date(this.newCast.startDate),
            endDate: new Date(this.newCast.endDate),
            company: this.activeCompData.id,
            uploadedBy: this.newCast.uploadedBy,
            Image: this.newCast.Image,
            delay: this.newCast.delay * 1000,
            createDate: this.today,
          })
          .then(async (docRef) => {
            if (this.filename) {
              await this.uploadNewsImage(docRef.id);
              console.log("file is in");
            }
          })

          .then(() => {
            this.$emit("updateData");
            this.closeAddCastDialog();
            console.log("Cast succesfully added");
          });
      } else {
        this.feedback = "Vul alle velden in om een Cast toe te voegen.";
      }
    },

    uploadNewsImage(docId) {
      // Afbeelding uploaden en News doc updaten
      return new Promise((resolve, reject) => {
        console.log("start storen");
        const file = this.file;
        const filename = this.filename;
        const ext = filename.slice(filename.lastIndexOf("."));
        const fileUrl = "castimages/" + docId + ext;
        this.uploading = true;
        let uploadTask = firebase
          .storage()
          .ref(fileUrl)
          .put(file);

        uploadTask.on(
          "state_changed",
          (taskSnapshot) => {
            var progress = Math.ceil(
              (taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) * 100,
            );
            this.uploadProgress = progress;
          },
          (error) => {
            console.log(error);
            reject();
          },
          () => {
            console.log("The upload is compleet");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then((url) => {
                db.collection("Casting")
                  .doc(docId)
                  .update({
                    Image: url,
                  })
                  .then(() => {
                    resolve();
                    this.uploading = false;
                    this.uploadProgress = null;
                  })
                  .catch((error) => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                  });
              })
              .catch((error) => {
                reject();
                this.uploading = false;
                this.uploadProgress = null;
              });
          },
        );
      });
    },

    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
  },

  computed: {
    startDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.newCast.startDate);
    },
    endDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.newCast.endDate);
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
  },
};
</script>

<style>
.custom-label {
  font-size: 16px;
  padding: 15px 0 5px;
  display: inline-block;
}

.upload-news-image-wrapper {
  padding: 20px 0;
}

.software-version-number {
  width: 35px;
  display: inline-block;
  margin: 4px 4px 4px 0;
  font-size: 14px;
  font-weight: bold;
}

.software-version-date {
  display: inline-block;
  font-size: 12px;
  width: 120px;
}
.software-version-author {
  display: inline-block;
  font-size: 12px;
  width: 110px;
}
</style>
